/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ReportIdNameReference } from './reportIdNameReference';
import type { ReportIdTitleReference } from './reportIdTitleReference';

export interface ThumbsDownRow {
  sessionId: string;
  voteId: string;
  at: string;
  reason: string;
  student: ReportIdNameReference;
  module: ReportIdTitleReference;
  task: ReportIdTitleReference;
}
